// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__26PQU","select":"Header_select__258_8","clinic":"Header_clinic__3g8h2"};